import React, { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DialogContentText from "@mui/material/DialogContentText";
export default function DeleteDialog({ show, message, dialogClose, Delete }) {
	const handleClose = useCallback(
		(event) => {
			dialogClose(false);
		},
		[dialogClose]
	);

	return (
		<Dialog
			open={show}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					Delete "{message}" ?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} autoFocus>
					Cancel
				</Button>
				<Button onClick={Delete}>Yes</Button>
			</DialogActions>
		</Dialog>
	);
}
